'use client'

import { supabase } from "@/lib/supabase/browser-client"
import { printObject } from "@/lib/utils"
import { createClientLogger } from "@/utils/logger/clientLogger"
import React from 'react'
import type { ErrorInfo } from 'react'

const logger = createClientLogger('util.errorBoundary', supabase)

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

	componentDidCatch(error: Error, info: ErrorInfo) {
		logger.error(`ErrorBoundary caught, error:${printObject(error)}, info:${printObject(info)}`)
	}

  componentDidUpdate() {
    if (this.state.hasError) {
      // Try reload once; if still error, strip URL and reload base
      window.location.replace('/')
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen items-center justify-center">
          <span className="text-lg text-gray-600">Something went wrong. Reloading…</span>
        </div>
      )
    }
    return this.props.children
  }
}